module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEESURBVHgBtVNtEYJAEL1jDEADsAE2oAE0kAbQQCNAA2hAA7GBJhAbQAJ8qwuzLOL4Q3fmzXH78XbfAsb804ZhCAD/U45dKXRxpEAA9MANKKy13SoBihIcPuABLhc0IhZx6hVogXoiREIM5DyyKyeREvgecu6TcMMxnxkvIjlgGRbPJU3DHRtusqU8h/Nds7QEqIAjEKtYN6shjaxTStKWqXgkJ2jMa+NGTUSSauUzPNF9IoC2FocnF8hG/t4szRv35QhnAWQqkTrtpQNNDjjK8W5VkAInsFf0uhQZdSTdO8R1ozmJXJjwp9xgZmufcsKjUwHtJQTO6Jx/RaCIyOp3/8FP7AFLcqKOs2BGwwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/form/safe.png
// module id = x23S
// module chunks = 0